import i18n from "../assets/translations/i18n"

export interface ApiError extends Error {
    statusCode?: number
    code?: string
    domainCode?: string
    details?: unknown
    userMessage?: string
    response?: {
        data?: {
            message?: string
        }
    }
}

export type UnknownRecord = Record<string, any>

export function getErrorMessage(
    error: unknown,
    fallback?: string
): string {
    const resolvedFallback = fallback ?? (i18n.t("common.genericError") as string)
    if (!error || typeof error !== "object") {
        return resolvedFallback
    }

    const typedError = error as ApiError
    return (
        typedError.userMessage ||
        typedError.response?.data?.message ||
        typedError.message ||
        resolvedFallback
    )
}
